(() => {
  const SELECTOR = '[data-interruption-banner]';

  // Optional: keep this while testing; remove later if you want
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'BANNER_JS_LOADED' });

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  const initBanner = (el) => {
    if (!el || el.dataset.ibInit === '1') return;
    el.dataset.ibInit = '1';

    const isDesignMode = !!(window.Shopify && Shopify.designMode);
    const forceShow = (el.dataset.forceShow === 'true');

    const freq = clamp(Number(el.dataset.frequency || 0), 0, 100);
    const once = (el.dataset.oncePerSession === 'true');

    // Ensure stable id for session keys
    if (!el.id) {
      el.id = `InterruptionBanner-${Math.random().toString(16).slice(2)}`;
    }
    const bannerId = el.id;

    const seenKey = `interruptionBannerSeen:${bannerId}`;
    const impKey  = `interruptionBannerImpression:${bannerId}`;

    // ---- Decide whether to show ----
    let shouldShow = false;

    if (forceShow || isDesignMode) {
      shouldShow = true;
    } else {
      if (once && sessionStorage.getItem(seenKey) === 'true') return;
      shouldShow = (Math.random() * 100) < freq;
    }

    if (!shouldShow) return;

    // ---- Show it ----
    el.classList.add('is-visible');

    if (once && !forceShow && !isDesignMode) {
      sessionStorage.setItem(seenKey, 'true');
    }

    // ---- Click tracking (NEW) ----
    // Add only once (separate flag so ibInit still controls overall init)
    if (el.dataset.ibClickInit !== '1') {
      el.dataset.ibClickInit = '1';

      const clickTypeFromTarget = (target) => {
        // Adjust these selectors to match your markup if needed
        if (target.closest('[data-ib-close]')) return 'close';
        if (target.closest('a, button, [data-ib-cta]')) return 'cta';
        return 'banner';
      };

      el.addEventListener('click', (e) => {
        // Only count clicks when banner is actually visible
        if (!el.classList.contains('is-visible')) return;

        const click_type = clickTypeFromTarget(e.target);

        // Optional: capture link URL if CTA is a link
        const linkEl = e.target.closest('a');
        const click_url = linkEl ? linkEl.href : null;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'interruption_banner_click',
          click_type, // cta | close | banner
          click_url,  // full URL or null
          placement_template: el.dataset.template || 'unknown',
          placement_path: el.dataset.path || window.location.pathname,
          banner_id: bannerId
        });
      });
    }

    // ---- Impression ----
    // Respect once-per-session for impressions in production,
    // but DO NOT block impressions when testing (forceShow) or in theme editor.
    if (!forceShow && !isDesignMode && sessionStorage.getItem(impKey) === 'true') return;

    const fireImpression = () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'IB_FIRE_CALLED', banner_id: bannerId });

      window.dataLayer.push({
        event: 'interruption_banner_view',
        placement_template: el.dataset.template || 'unknown',
        placement_path: el.dataset.path || window.location.pathname,
        banner_id: bannerId
      });

      if (!forceShow && !isDesignMode) {
        sessionStorage.setItem(impKey, 'true');
      }
    };

    // Fire immediately after showing
    fireImpression();
  };

  const initAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initBanner);
  };

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  // Theme editor / dynamic section loads
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
